<template>
  <div ref="map-wrapper" :class="['expandable-wrapper', {'expandable-wrapper--expanded': expanded}, 'h-100', ]">
    <div v-if="expanded" class="coverage-map-backgrop position-fixed" @click="collapse" />
    <div :class="['position-relative', 'h-90', {'coverage-map-container': expanded}]">
      <div class="expandable-wrapper__menu position-absolute d-flex w-100 p-3 justify-content-end">
        <span class="cursor-pointer" @click="collapse">
          <font-awesome-icon size="lg" icon="compress-alt" />
        </span>
      </div>
      <coverage-map
        ref="coverage-map"
        :selectedRegions="selectedAreas"
        :initialAreas="initialAreas"
        @outcodesSelected="onRegionSelected"
        @outcodesDeselected="onRegionDeselected"
        @areaOpened="onAreaOpened"
        @areaSelected="onAreaSelected"
        @areaDeselected="onAreaDeselected"
      />
    </div>
  </div>
</template>

<script>
import CoverageMap from '@/components/map/CoverageMap/index';

export default {
  name: "PostcodeMap",
  components: {CoverageMap},
  props: ['value'],
  data() {
    return {
      expanded: false,
      cachedOutcodes: {},
      regionLoading: false,
      cachedLoadingOutcodes: new Set(),
    }
  },
  computed: {
    selectedAreas() {
      return this.value.map((v) => v.name);
    },
    initialAreas: function () {
      return this.$store.state.coverage.SELECTED_COVERAGE_AREAS;
    },
  },
  methods: {
    expand() {
      this.expanded = true
    },
    collapse() {
      this.expanded = false;
    },
    onRegionSelected(selectedRegions) {
      if (this.regionLoading) {
        for (const r of selectedRegions) {
          this.cachedLoadingOutcodes.add(r);
        }
      } else {
        this.$emit('input', [...this.value, ...selectedRegions.map(r => this.cachedOutcodes[r])]);
      }
    },
    onRegionDeselected(deselectedRegions) {
      if (this.regionLoading) {
        for (const r of deselectedRegions) {
          this.cachedLoadingOutcodes.delete(r);
        }
      }
      for (const region of deselectedRegions) {
        const index = this.value.findIndex((r) => r.name === region);
        if (index > -1) {
          this.value.splice(index, 1);
        }
      }
      this.$emit('input', [...this.value]);
    },
    onAreaOpened(region) {
      this.regionLoading = true;
      this.cachedLoadingOutcodes = new Set();
      this.$api.coverageRegion.find(region).then((response) => {
        for (const outcode of response.data.data) {
          this.cachedOutcodes[outcode.name] = outcode;
        }
        if (this.cachedLoadingOutcodes.size > 0) {
          const storedOutcodes = [];
          for (const [r] of this.cachedLoadingOutcodes.entries()) {
            storedOutcodes.push(this.cachedOutcodes[r]);
          }
          this.$emit('input', [...this.value, ...storedOutcodes]);
        }
        this.regionLoading = false;
      });
    },
    onAreaSelected(region) {
      this.$api.coverageRegion.find(region).then((response) => {
        const filteredResponse = response.data.data.filter((area) => this.value.find((location) => location.id === area.id) === undefined);
        this.$emit('input', [...this.value, ...filteredResponse]);
      });
    },
    onAreaDeselected(areaName) {
      this.$emit(
        'input',
        this.value
          .filter(region => region.parent.name !== areaName)
          .sort((a, b) => a.name
            .localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
      );
    },
  },
  watch: {
    expanded() {
      this.$nextTick(() => this.$refs['coverage-map'].onResize());
    }
  }
}
</script>

<style scoped lang="scss">
.expandable-wrapper {
  background-color: $white;

  &--expanded {
    position: fixed;
    z-index: 15;
    width: 90vw;
    height: 90vh;
    left: 5vw;
    top: 80px;
    box-shadow: $box-shadow-secondary;

    .expandable-wrapper__menu {
      top: -5px;
      left: 0;
      z-index: 2;
    }
  }

  .coverage-map-container {
    z-index: 30;
  }

  .expandable-wrapper__menu {
    display: none;
  }

  .coverage-map-backgrop {
    opacity: 1;
    background: rgba(1, 54, 82, .2);
    top: 0;
    left: 0;
    z-index: 2;
    width: 100vw;
    height: 100vh;
  }
}
</style>
